// @flow
import * as React from 'react';
import Helmet from 'react-helmet';
import styled, { withTheme } from 'styled-components';

import type { MessageType } from 'common/components/PageMessage';
import PageMessage from 'common/components/PageMessage';

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledContainer = styled.div`
  height: 100%;
  overflow: hidden;

  min-height: calc(100vh - ${({ theme }) => theme.metrics.navBarHeight}px);
  display: flex;
  align-items: center;
  flex-direction: column;

  padding: ${({ theme }) => theme.metrics.largeMargin}px;
  padding-top: ${({ theme }) => theme.metrics.margin}px;

  @media only screen and (max-width: 600px) {
    padding-bottom: ${({ theme }) => theme.metrics.margin}px;
  }
`;

const PageWrapper = styled.div`
  width: 100%;

  max-width: ${({ isFluid }) => (isFluid ? '100%' : '1920px')};

  @media only screen and (max-width: 600px) {
    max-width: 100%;
  }

  ${({ isSmall }) => isSmall && `
    @media (min-width: 1200px) {
      width: 80%;
    }
  `}
`;

const Header = styled.div`
  text-align: center;

  width: 100%;
  max-width: ${({ isFluid }) => (isFluid ? '100%' : '1920px')};

  @media only screen and (max-width: 600px) {
    max-width: 100%;
  }
`;

type Message = {
  message: string,
  type: MessageType,
}

type Props = {
  title: string,
  fluid: boolean,
  small: boolean,
  hideTitle?: boolean,
  floatingComponents?: any,

  messages: Message[],

  children: any,
  theme: any,
  style: Object,
  className: string,
}

function Page({ title, small, fluid, hideTitle, floatingComponents, children, theme, style, className, messages }: Props) {
  const isFluid = fluid || false;
  const isSmall = (small || false) && !isFluid;
  const allMessages = messages || [];

  return (
    <ContentWrapper>
      {allMessages.map(({ message, type }) =>
        <PageMessage key={message + type} message={message} type={type} />)
      }
      <StyledContainer style={style} className={className}>
        <Helmet>
          <title>{title}</title>
        </Helmet>

        {floatingComponents}

        {!hideTitle &&
          <Header>
            <h1 style={theme.fonts.style.pageTitle}>{title.toUpperCase()}</h1>
          </Header>
        }

        <PageWrapper isFluid={isFluid} isSmall={isSmall}>
          {children}
        </PageWrapper>
      </StyledContainer>
    </ContentWrapper>
  );
}

export default withTheme(Page);



// WEBPACK FOOTER //
// ./src/statsradio/components/page/PageStylesV1.js